var exports = {
  "v": "tableDrag__IubqLV",
  "A": "tableHeaderDrag__OnjgBr",
};

module.exports = exports;
